<<template>
  <div class="payment-wrapper no-label-css">
    <h3>Payment</h3>
    <div class="payment-box" v-if="savedCardsLoaded || !loggedIn">
      <b-form-group label="Payment Method" v-if="savedCardsLoaded">
        <b-form-select v-model="form.saved_card" :options="savedCardOptions">
          <!-- this option appears at end -->
          <option :value="null">Add New card...</option>
        </b-form-select>
      </b-form-group>

      <div v-if="!form.saved_card">
        <div class="row">
          <div class="col-sm-12">
            <div class="card-row">
              <img class="credit-card" src="/static/images/creditcards/visa.svg">
              <img class="credit-card" src="/static/images/creditcards/mastercard.svg">
              <img class="credit-card" src="/static/images/creditcards/amex.svg">
              <img class="credit-card" src="/static/images/creditcards/discover.svg">
            </div>
          </div>
        </div>

        <!--card number -->

        <div class="form-group">
          <div class="required">
            <div class="input-group">
              <input v-model="form.card_number" id="card_number" type="text" class="form-control" placeholder="Credit Card Number" v-validate="'required|credit_card'" required/>
              <span class="input-group-addon">
                <svg class="icon icon-lock"><use xlink:href="#icon-lock"></use></svg>
              </span>
            </div>
          </div>
        </div>

        <!--exp / -->


        <div class="row">
          <div class="col-sm-6 col-md-4">
            <div class="form-group">
              <div class="required">
                <input type="text" v-model="form.expiration" @blur="fixExpiration" id="expiration" class="form-control" placeholder="MM/YY" v-validate="'required|date_format:MM/YY'" required>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <div class="required">
                <!--validate 3-4 digits https://stackoverflow.com/questions/13178912/regex-for-matching-certain-numbers-of-digits-->
                <input type="text" v-model="form.cvc" id="cvc" class="form-control" placeholder="CVC" data-stripe="cvc" v-validate="{ required: true, regex: /^\d{3}(\d{1})?$/ }" required>
              </div>
            </div>
          </div>
          <a id="shield" target="_blank" href="https://ssl.comodo.com/wildcard-ssl-certificates.php">
          <img src="/static/images/creditcards/comodo-seal.svg" alt="Comodo Trusted Site Seal" width="auto" height="40" style="border: 0px;"></a>
        </div>

        <div v-if="allowSave">
          <b-checkbox v-model="form.save_card">Save card for future use</b-checkbox>
          <div v-if="form.save_card">
            <div class="required">
              <input v-model="form.title" id="title" type="text" class="form-control" placeholder="Description of card" v-validate="'required'" required/>
            </div>
            <PrivateToggle dark v-model="form.is_private" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
@import '~scss/colors';
  /*:host {*/

  .payment-wrapper {
    margin-top:15px;
    }

  .payment-box {
    background-color: #ededed;
    border:$gray-1 1px solid;
    padding: 1em 2em 2em 2em;

    & div{
      max-width: 450px;
    }
  }

   .input-group-addon{
     background-color: $gray-1;
     padding-left:15px;
   }

    .input-group-addon{
      border: 1px solid rgba(0,0,0,.15);
      border-top-right-radius: .25rem !important;
      border-bottom-right-radius: .25rem !important;
    }

    .form-control {
      background-color: $white;
    }

    .required {
      &:after {
        background-color: transparent;
      }
    }

    .card-row {
      display:flex;
      margin-bottom: 16px;
      margin-right: 3px;
      margin-top: 1em;
      background-repeat: no-repeat;
      background-size: contain;

      & .credit-card{
      width: 48px;
      height: 30px;
      }
    }

    .checkbox-height-fix {
      position: relative;
      height: 2em;
      margin: 0 0 0 .5em;
    }

    @media (max-width: 767px) {
    #shield {
    margin: 0 0 1em 1em;
    }
  }

</style>

<style>
/* Unscoped to fix color of checkbox indicator*/
.checkbox-height-fix .custom-control-description {
  color: #323237;
}
.checkbox-height-fix .custom-control-indicator {
  background: white;
}
</style>

<script>
import {empty_payment} from '@/lib/CheckoutLogic';
import {mapGetters, mapActions} from 'vuex';
export default {
  data() {
    return {
      form: {
        ...empty_payment(),
        saved_card: '',    // blank signals that a default needs to be chosen
        save_card: false,
        title: '',
        is_private: true,
      }
    }
  },
  props:{
    // Note: this is the "incoming" value. We largely ignore this.
    value: {
      type: Object
    },
    hasCardOnFile: {
      default: true
    }
  },
  computed: {
    ...mapGetters(['savedCards', 'savedCardsLoaded', 'defaultSavedCard', 'loggedIn']),
    savedCardOptions() {
      return this.savedCards.map(c => ({value: c.id, text: c.title}));
    },
    allowSave() {
      return this.loggedIn;
    }
  },
  watch: {
    form: {
      deep: true,
      handler(val) {
        this.$emit('input', val);
      }
    },
    async loggedIn(val) {
      if (val) {
        await this.loadSavedCards();
        this.chooseDefaultCard();
      }
    }
  },
  methods: {
    ...mapActions(['loadSavedCards']),
    chooseDefaultCard() {
      if (this.form.saved_card !== '') {
        console.log('default already chosen', JSON.stringify(this.form.saved_card));
        return; // default already chosen
      }
      console.log("chooseDefaultCard=>", this.defaultSavedCard || null);
      this.form.saved_card = this.defaultSavedCard || null;
    },
    fixExpiration() {
      this.form.expiration = this.form.expiration.replace(/^(\d\d)(\d\d)$/, "$1/$2");
    }
  },
  async mounted() {
    if (this.loggedIn) {
      await this.loadSavedCards();
      this.chooseDefaultCard();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/checkout/CheckoutPayment.vue